import './Title.css';

export default function Title() {
    return (
        <div className='Title'>
           <h1><a href="#">ANTÓNIO ROCHA</a></h1> 
        </div>
    )
}